import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CSHero } from '../components/clearsilk/CSHero';
import { CSWhatIs } from '../components/clearsilk/CSWhatIs';
import { CSTreatment } from '../components/clearsilk/CSTreatment';
import { CSStandOut } from '../components/clearsilk/CSStandOut';
import { CSWhyPrefer } from '../components/clearsilk/CSWhyPrefer';
import { CSCombine } from '../components/clearsilk/CSCombine';
import { CSAddOns } from '../components/clearsilk/CSAddOns';
import { CSFAQ } from '../components/clearsilk/CSFAQ';
import { CSWhyChoose } from '../components/clearsilk/CSWhyChoose';
export function ClearSilkPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2467">
      <Navigation data-id="element-2468" />
      <main data-id="element-2469">
        <CSHero data-id="element-2470" />
        <CSWhatIs data-id="element-2471" />
        <CSTreatment data-id="element-2472" />
        <CSStandOut data-id="element-2473" />
        <CSWhyPrefer data-id="element-2474" />
        <CSCombine data-id="element-2475" />
        <CSAddOns data-id="element-2476" />
        <CSFAQ data-id="element-2477" />
        <CSWhyChoose data-id="element-2478" />
      </main>
      <Footer data-id="element-2479" />
    </div>;
}